import React, {Suspense} from "react";
import {withRouter} from "../../../Utility/withRouter";
import Header from "../../../Header/Header";
import Footer from "../../../Footer/Footer";
import {machines} from "../../../Utility/Static";
import {useLocation} from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import {Carousel, CarouselItem} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function MobilesBohrWerk() {
    const location = useLocation();
    const machine = machines.find((m => m.typ === `Supercombinata easy`))!;
    if (location.pathname.endsWith("/a")) {
        return (
            <div className={"page"}>
                <Header/>
                <div className={"content flexColumn alignContentCenter marginAuto"}>
                    <h1 className={"title"}>Mobiles Bohrwerk</h1>
                    <div className={"block flexRow"}>
                        <div className={"blockLeft flexColumn fullHeight"}>
                            <Suspense fallback={<div className={"loadingSpinner"}><Spinner animation="grow"/></div>}>
                                <Carousel slide={true}
                                          pause={'hover'}
                                          touch={true}>
                                    {
                                        machine.images.map((img) => {
                                            return (
                                                <CarouselItem key={img.url}
                                                              className={"machine"}>
                                                    {
                                                        <img
                                                            className="d-block w-100"
                                                            src={img.url}
                                                            alt={img.alt}
                                                        />
                                                    }
                                                </CarouselItem>
                                            )
                                        })
                                    }
                                </Carousel>
                            </Suspense>
                        </div>
                        <div className={"blockLeft flexColumn fullHeight alignContentCenter"}>
                            <p>Wir schweißen und spindeln eure defekten Baugruppen vor Ort oder beu uns im Haus.
                                Das Auftragsschweißen und Ausspindel ab &#8709;32-250mm sowie eine Planbearbeitung der
                                Fläche für uns problemlos möglich.
                                Wir fertigen hierzu auch gleich die passenden Wellen und Buchsen auf unseren
                                CNC-Maschinen.
                            </p>
                        </div>
                    </div>

                    <h3>Eckdaten des mobilen Bohrwerks</h3>
                    <table className={"performanceTable"}>
                        <tbody>
                        {
                            machine.eckdaten.map((eckdaten) => {
                                if (eckdaten[2]) {
                                    return (
                                        <tr key={eckdaten[0]}>
                                            <th>{eckdaten[0]}</th>
                                            <td>{eckdaten[1]}</td>
                                        </tr>
                                    )
                                } else return null;
                            })

                        }</tbody>
                    </table>
                </div>
                <Footer/>
            </div>

        )
            ;
    } else return (
        <div className={"page"}>
            <Header/>
            <div className={"content flexColumn alignContentCenter marginAuto"}>
                <h1 className={"title"}>Mobiles Bohrwerk</h1>
                <div className={"block flexRow"}>
                    <div className={"blockLeft flexColumn fullHeight"}>
                        <Suspense fallback={<div className={"loadingSpinner"}><Spinner animation="grow"/></div>}>
                            <Carousel slide={true}
                                      pause={'hover'}
                                      touch={true}>
                                {
                                    machine.images.map((img) => {
                                        return (
                                            <CarouselItem key={img.url}
                                                          className={"machine"}>
                                                {
                                                    <img
                                                        className="d-block w-100"
                                                        src={img.url}
                                                        alt={img.alt}
                                                    />
                                                }
                                            </CarouselItem>
                                        )
                                    })
                                }
                            </Carousel>
                        </Suspense>
                    </div>
                    <div className={"blockLeft flexColumn fullHeight alignContentCenter"}>
                        <p>Wir schweißen und spindeln eure defekten Baugruppen vor Ort oder beu uns im Haus.
                            Das Auftragsschweißen und Ausspindel ab &#8709;32-250mm sowie eine Planbearbeitung der
                            Fläche für uns problemlos möglich.
                            Wir fertigen hierzu auch gleich die passenden Wellen und Buchsen auf unseren
                            CNC-Maschinen.
                        </p>
                    </div>
                </div>
                <div className={"performances flexColumn alignContentCenter marginAuto"}>
                    {
                        machine.eckdaten.map((daten) => {
                            return (
                                <div className={"performanceRow marginAuto flexRow"} key={daten[0]}>
                                    <FontAwesomeIcon color={"red"} size={"xl"} icon={["fas", "circle-check"]}/>
                                    <p>{daten[0] + ": " + daten[1]}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <Footer/>
            </div>
        </div>
    );
}

export default withRouter(MobilesBohrWerk);